/**
 * Input checkbox type
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
/**
 * Material UI
 */
import { makeStyles } from '@mui/styles';
/**
 * Helpers
 */
import Utils from '../../helpers/utils';

const useStyles = makeStyles(() => ({
  checkboxField: {
    maxHeight: 'none !important',
  },
}));

/**
 * InputText
 *
 * @param debounceTime {number} Time after to call formik update
 * @param required {boolean} Required field
 * @param label {string} Label of input text
 * @param name {string} key of formik.values to get value
 * @param errorMessage {string} Error message to print
 * @param formik {object} the formik object passed as prop
 * @param className {string} Class to assign to field
 *
 * @returns {JSX.Element}
 */
function InputCheckbox({
  debounceTime,
  required,
  label,
  name,
  errorMessage,
  formik,
  className,
}) {
  const classes = useStyles();
  const [value, setValue] = useState(false);
  const onDebouncedChange = Utils.useDebouncedCallback(debounceTime);

  // Update value if formik object changes
  useEffect(() => {
    const formikFieldValue = formik.values[name];
    if (formikFieldValue !== value) {
      setValue(formikFieldValue);
    }
  }, [formik.values]);

  return (
    <div className={`${className} ${classes.checkboxField}`}>
      <label
        className="styled-checkbox"
        htmlFor={name}
      >
        <span
          className="text"
          dangerouslySetInnerHTML={{
            __html: `${label}${required ? ' *' : ''}`,
          }}
        />
        <input
          type="checkbox"
          id={name}
          name={name}
          data-required={required}
          onChange={(event) => {
            setValue(event.target.checked);
            onDebouncedChange(() => {
              formik.handleChange(event);
            });
          }}
          onBlur={formik.handleBlur}
          checked={value === true}
        />
        <span className="checkmark" />
      </label>
      <span className="mdl-textfield__error">{errorMessage}</span>
    </div>
  );
}
InputCheckbox.defaultProps = {
  debounceTime: 200,
  required: false,
  label: '',
  className: '',
  errorMessage: '',
};
InputCheckbox.propTypes = {
  debounceTime: PropTypes.number,
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  formik: PropTypes.shape({
    values: PropTypes.shape({}).isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
  }).isRequired,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
};

export default InputCheckbox;
